import { IFormData } from "../../pages/Authentication/SignInPage";
import { axiosInstanceNoAuth } from "./setup";

export const handleLoginApi = async (formData: IFormData) => {
  return axiosInstanceNoAuth().post(`/admin/login`, formData);
};
